import React from 'react'
import styled from 'styled-components'

import colors from 'styles/colors'
import text from 'styles/text'
import media from 'styles/media'

import links from 'utils/links'
import { useContext } from "react";
import { ScreenContext } from "components/Providers";

import { ReactComponent as GoogleSVG } from 'assets/images/icons/google.svg' 

type Props = { 
    long?: boolean
}

const GooglePlay: React.FC<Props> = ({ long }) => {

  const { mobile } = useContext(ScreenContext);
  const handleClick = () => {
    window.open(links.google, 'blank')
  }

  return ( 
    <Wrapper long={long} onClick={handleClick}>
      {!long && (
        <SVG viewBox="0 0 202 56">
          <Path d="M 0.5 0.5 H 187 L 201.5 15 V 55.5 H 15 L 0.5 41 Z"/>
        </SVG>
      )}

      {long && !mobile && (
        <SVG viewBox="0 0 904 56">
          <Path d="M 0.5 0.5 H 889 L 903.5 15 V 55.5 H 15 L 0.5 41 Z"/>
        </SVG>
      )}

      {mobile && (
        <SVG viewBox="0 0 345 56">
          <Path d="M 0.5 0.5 H 332 L 344.5 15 V 55.5 H 15 L 0.5 41 Z" />
        </SVG>
      )}
    
      <Content>
        <GoogleLogo/> Google Play
      </Content>
    </Wrapper>
  )
}

export default GooglePlay

const SVG = styled.svg`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  fill: none;
`

const Path = styled.path`
  stroke: ${colors.pureWhite};   
`

const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  ${text.desktop.button}
  color: ${colors.pureWhite};
  transition: 500ms;
  position: relative;
  z-index: 5;

  ${media.tablet} {
    ${text.tablet.button}
  }

  ${media.mobile} {
    ${text.mobile.button}
  }
`

const GoogleLogo = styled(GoogleSVG)`
  width: 1.94vw;
  height: 2.36vw;
  margin-right: 1.11vw;

  ${media.tablet} {
    width: 2.73vw;
    height: 3.32vw;
    margin-right: 1.56vw;
  }

  ${media.mobile} {
    width: 8vw;
    height: 8vw;
    margin-right: 4vw;
  }
`

const Wrapper = styled.div<{long?: boolean}>`
  position: relative;
  cursor: pointer;

  svg {
    path {
      transition: 500ms;
    }
  }

  &:hover {
    ${Path} {
      fill: ${colors.pureWhite};
    }

    ${Content} {
      color: ${colors.pureBlack};

      svg {
        path {
          fill: ${colors.pureBlack};
        }
      }
    }
  }

  height: 3.89vw;
  width: 14.03vw;

  ${media.tablet} {
    width: ${props => props.long ? '88.28vw' : '19.73vw'};
    height: 5.47vw;
  }

  ${media.mobile} {
    width: 92vw;
    height: 14.933vw;
  }
`